module.exports = __webpack_public_path__ + "4c189bda656b46819eaf555104cf4a1c.svg";